import { useTheme } from '@sport1/react-elements'
import colorPattern from '../../DesignSystem/colors'
import { Variants } from '../../DesignSystem/types'

export const useTabVariantStyles = (
    tabVariant: Extract<Variants, 'primary' | 'secondary' | 'tertiary'>
): { backgroundColor: string; fontColor: string; selectionColor?: string } => {
    const { themeName } = useTheme() as { themeName: 'light' | 'dark' }

    switch (themeName) {
        case 'light':
            switch (tabVariant) {
                case 'primary':
                    return {
                        backgroundColor: colorPattern.pearl,
                        fontColor: colorPattern.onyx,
                        selectionColor: colorPattern.onyx,
                    }
                case 'secondary':
                    return {
                        backgroundColor: colorPattern.onyx,
                        fontColor: colorPattern.pearl,
                        selectionColor: colorPattern.pearl,
                    }
                case 'tertiary':
                    return {
                        backgroundColor: colorPattern.sky,
                        fontColor: colorPattern.pearl,
                        selectionColor: colorPattern.pearl,
                    }
            }
        case 'dark':
            switch (tabVariant) {
                case 'primary':
                    return {
                        backgroundColor: colorPattern.smoke,
                        fontColor: colorPattern.pearl,
                        selectionColor: colorPattern.pearl,
                    }
                case 'secondary':
                    return {
                        backgroundColor: colorPattern.pearl,
                        fontColor: colorPattern.onyx,
                        selectionColor: colorPattern.onyx,
                    }
                case 'tertiary':
                    return {
                        backgroundColor: colorPattern.sky,
                        fontColor: colorPattern.pearl,
                        selectionColor: colorPattern.pearl,
                    }
            }
    }
}
